export default "__VITE_ASSET__DS1xnkPw__"